/**
 * Constants definition.
 *
 * @type {{STATE_MIPYME: string, PRIVATE_MIPYME: string, CNA: string}}
 */
const SUBJECT_TYPE = {
  STATE_MIPYME: 'STATE_MIPYME',
  PRIVATE_MIPYME: 'PRIVATE_MIPYME',
  CNA: 'CNA',
  ORGANIZATION_PMS: 'ORGANIZATION_PMS',
  TCP_PROPOSAL: 'TCP_PROPOSAL',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const SUBJECT_TYPE_ENUM = Object.keys(SUBJECT_TYPE);

const STATE_MIPYME = SUBJECT_TYPE_ENUM[0];
const PRIVATE_MIPYME = SUBJECT_TYPE_ENUM[1];
const CNA = SUBJECT_TYPE_ENUM[2];
const ORGANIZATION_PMS = SUBJECT_TYPE_ENUM[3];
const TCP_PROPOSAL = SUBJECT_TYPE_ENUM[4];

export {
  SUBJECT_TYPE,
  STATE_MIPYME,
  CNA,
  PRIVATE_MIPYME,
  ORGANIZATION_PMS,
  SUBJECT_TYPE_ENUM,
  TCP_PROPOSAL,
};
